/**
 *
 * PortalModal
 *
 * @version 0.0.5
 * @author Giuseppe
 * @since 12-Oct-2022
 */

import React from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography } from '@mui/material';
import { generateUniqueId } from '../../utils/generateUniqueID';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import PortalButton from '../PortalButton/PortalButton';
import Success from 'Assets/images/gif/animation_positivo.gif';
import Failure from 'Assets/images/gif/animation_negativo.gif';
import Warning from 'Assets/images/svg/icon_warning.svg';
import style from './PortalModal.scss';

const PortalModal = (props) => {
	const intl = useIntl();
	return props.open ? (
		<>
			<Grid className={style.darkBackground} />
			<Dialog
				className={`${style.dialog} ${props.isBig ? style.isBig : ''} ${props.className}`}
				onClose={() => {}}
				open>
				{props.hasOutcome ? (
					props.outcome === 'success' ? (
						<Grid className={style.iconGif}>
							<img src={Success} alt='Success' />
						</Grid>
					) : props.outcome === 'failure' ? (
						<Grid className={style.iconGif}>
							<img src={Failure} alt='Failure' />
						</Grid>
					) : props.outcome === 'warning' ? (
						<Grid className={style.iconGif}>
							<img src={Warning} alt='Warning' />
						</Grid>
					) : (
						''
					)
				) : (
					''
				)}
				{props.title ? (
					<DialogTitle>{props.isTranslatedMessage ? intl.formatMessage(props.title) : props.title}</DialogTitle>
				) : null}
				{props.closeIcon ? (
					<IconButton className={style.iconClose} onClick={props.actions.handleClose} aria-label='close'>
						<i className='nexi-icons-close' />
					</IconButton>
				) : null}
				<DialogContent>
					{props.subtitle ? (
						<Typography>
							{intl.formatMessage(
								props.subtitle,
								props.subtitleValues
									? {
											element: intl.formatMessage(props.subtitleValues),
									  }
									: null
							)}
						</Typography>
					) : (
						''
					)}
					{props.children}
				</DialogContent>
				{props.buttons && props.buttons.length > 0 ? (
					<DialogActions>
						{props.buttons.map((button, index) => (
							<PortalButton
								variant={button.variant === 'outlined' ? 'outlined' : 'contained'}
								key={`portal-modal-${index}-${props.key}`}
								isDisabled={button.isButtonDisabled}
								onClick={() => {
									if (button.onClick) button.onClick();
									props.actions.handleClose(); //close modal
								}}
								contentText={button.contentText}
								path={button.path}
								isLoading={button.isLoading}
							/>
						))}
					</DialogActions>
				) : null}
			</Dialog>
		</>
	) : null;
};

PortalModal.propTypes = {
	open: PropTypes.bool,
	icon: PropTypes.bool,
	key: PropTypes.string,
	title: PropTypes.shape({ id: PropTypes.string }),
	closeIcon: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	subtitle: PropTypes.PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	subtitleValues: PropTypes.shape({ id: PropTypes.string }),
	buttons: PropTypes.arrayOf(
		PropTypes.shape({
			onClick: PropTypes.func,
			contentText: PropTypes.shape({ id: PropTypes.string }),
			variant: PropTypes.string,
			path: PropTypes.string,
			isLoading: PropTypes.bool,
			isDisabled: PropTypes.bool,
		})
	),
	// isOpen: PropTypes.bool.isRequired,
	keepVisibleOnClick: PropTypes.bool,
	actions: PropTypes.objectOf(PropTypes.func),
	hasOutcome: PropTypes.bool,
	isBig: PropTypes.bool,
	outcome: PropTypes.string,
	handleClose: PropTypes.func,
	className: PropTypes.string,
	isTranslatedMessage: PropTypes.bool,
};

PortalModal.defaultProps = {
	open: true,
	icon: false,
	closeIcon: false,
	keepVisibleOnClick: true,
	key: generateUniqueId(),
	hasOutcome: false,
	isBig: false,
	outcome: '',
	handleClose: undefined,
	className: '',
	isTranslatedMessage: true,
};

export default PortalModal;
